export default __webpack_public_path__ + "static/media/contact.d9620443.png";